export { default } from './TextIndicator';
export * from './TextIndicator';
